const LEAD_MANAGER_API = "https://leads.maymarketingseo.com"
const CLIENT_SLUG = "skyline-roofing"

export interface LeadFormData {
  name: string
  email: string
  phone?: string
  service?: string
  message?: string
  location?: string
}

export interface LeadSubmissionResponse {
  success: boolean
  message: string
  leadId?: string
}

export async function submitLead(formData: LeadFormData): Promise<LeadSubmissionResponse> {
  try {
    const response = await fetch(`${LEAD_MANAGER_API}/api/${CLIENT_SLUG}/submit`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ formData }),
    })

    if (!response.ok) {
      return { success: false, message: "Failed to submit. Please call us directly." }
    }

    const data = await response.json()
    return {
      success: true,
      message: "Thank you! We've received your estimate request and will contact you soon.",
      leadId: data.id,
    }
  } catch {
    return { success: false, message: "Network error. Please call us directly." }
  }
}
